import { List, ListItemButton, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronRight } from "../../../icons";

type ItemSelectedMbProps = {
  isOpen?: boolean;
  label: string;
  onClick: () => void;
};
export const ItemSelectedMb = ({
  isOpen,
  label,
  onClick,
}: ItemSelectedMbProps) => {
  const theme = useTheme();
  return (
    <List disablePadding>
      <ListItemButton
        TouchRippleProps={{
          style: {
            color: theme.palette.primary[100],
          },
        }}
        onClick={onClick}
        sx={{
          display: "flex",
          gap: 1,
          paddingInline: 4,
          m: 1,
          paddingBlock: 0,
        }}
      >
        {isOpen ? (
          <ChevronDown sx={{ width: 12, height: 12 }} />
        ) : (
          <ChevronRight sx={{ width: 12, height: 12 }} />
        )}
        <Typography variant="overline" color="secondary">
          {label}
        </Typography>
      </ListItemButton>
    </List>
  );
};
